import { graphql } from "~/gql";

export const DELETE_NOTIFICATION_RULE = graphql(/* GraphQL */ `
  mutation DeleteNotificationRule($notificationRuleId: Float!) {
    deleteNotificationRule(notificationRuleId: $notificationRuleId) {
      notificationRuleId
    }
  }
`);
